<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center mb-3">
                <div class="col-md mb-2 mb-md-0">
                    <h1 class="page-header-title">Klienci API - Lista SMS</h1>
                </div>
                <div class="col-md-auto">
                </div>
            </div>
        </div>
        <div class="card">
            <div class="table-responsive">
                <table class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Odbiorca</th>
                            <th scope="col">Treść SMS</th>
                            <th class="text-end">
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item,index in items" :key="index">
                            <th scope="row">{{index+1}}</th>
                            <td>{{item.sms_to}}</td>
                             <td>{{item.sms_body}}</td>
                            <td class="text-end">
         
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from '../../api/helpdesk-axios.js';
import MagicoModal from '../MagicoModal.vue';
import DeleteConfirm from '../DeleteConfirm.vue';

export default {
    name: 'GroupIndex',
    components: {
        MagicoModal,
        DeleteConfirm
    },
    data: function() {
        return {
            items: [],
            modalQr: false,
            qrCodeUrl: '',
        }
    },
    methods: {
        load: function() {
            let vm = this;
            axios.get('api/v1/sms/client/'+this.$route.params.id+'/messages').then(function(response) {
                vm.items = response.data.data;
            })
        },
        openQrcode: function(item) {
            let vm = this;
            axios.get('api/v1/group/' + item.group_id + '/qrcode', {
                    responseType: 'arraybuffer',
                })
                .then(response => {
                    vm.qrCodeUrl = 'data:image/png;base64,' + Buffer.from(response.data, 'binary').toString('base64');
                })
            this.modalQr = true;
        },
        deleteGroup(group) {
            let vm = this;
            axios.delete('api/v1/group/' + group.group_id).then(function(response) {
                vm.load();
            })
        },
    },
    mounted() {
        if (!['owner', 'manager'].includes(this.$store.getters['app/role'])) {
            this.$router.push('/');
        }
        this.load();
    }
}
</script>